import { Controller } from "@hotwired/stimulus"

// Reports blog call-to-action clicks to GA4 as a `blog_cta_click` event so we
// can see which POST sends people to the store, not just which post gets read.
//
// A GA event, deliberately, rather than utm_* params on the link: utm_source
// on an INTERNAL link starts a new GA campaign/session, overwriting the
// visitor's real acquisition source (google/organic becomes blog/whatever).
// That would have destroyed the very attribution it was meant to create.
//
// gtag only exists in production (ThirdPartyTags.google_analytics_enabled?),
// so every call is guarded — a missing tag must never break a CTA click.
export default class extends Controller {
  static values = { campaign: String, placement: String }

  track() {
    if (typeof window.gtag !== "function") return

    window.gtag("event", "blog_cta_click", {
      campaign: this.campaignValue,
      placement: this.placementValue,
    })
  }
}
